import { createFileRoute } from '@tanstack/react-router'
import { useEntityTypeDetailValidContext } from '@admin/preferences/helper/EntityTypeDetailValidContext'
import EntityTypeStagesTab from '@admin/preferences/entities/EntityTypeStagesTab'

export const Route = createFileRoute('/_auth/preferences/entityTypes/$entityTypeId/stages')({
  component: RouteComponent,
})

function RouteComponent() {
  const { entityType } = Route.useRouteContext()
  const [, setValid] = useEntityTypeDetailValidContext()

  const handleDirty = (dirty: boolean) => {
    setValid(!dirty)
  }

  return <EntityTypeStagesTab entityType={entityType} onDirty={handleDirty} />
}
